import { useFeatureFlags } from 'src/context';
import { useAppBuilderAccess } from 'src/hooks/useAppBuilderAccess';

/**
 * Whether a referral URL should render the old /referrals page rather than
 * settings. Growth-loops moves the program into settings for plans that
 * include the app builder. Plans without that entitlement stay off the
 * settings page; route access hides the program itself (Help Center and the
 * old page).
 */
export const useLegacyReferralProgram = (): boolean => {
  const { EnableGrowthLoops } = useFeatureFlags();
  const { hasAppBuilderPlanAccess, isPlanAccessResolved } =
    useAppBuilderAccess();

  return (
    !EnableGrowthLoops || (isPlanAccessResolved && !hasAppBuilderPlanAccess)
  );
};
